import { Component, OnInit, TemplateRef, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { ParcelaPaginado, Paginacao, Parcela, ProcedenciaAcordo, ContaCredito, TransacaoCredito, ComprovanteContaCredito, ArquivoComprovanteContaCredito, FiltroConciliacao ,FiltroAcordo } from '../shared/services/acordo-ressarcimento/api/models';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import { ParcelaService, EscritoriosService, DominiosService, ContaCreditoService, TransacaoCreditoService, UsuarioService } from '../shared/services/acordo-ressarcimento/api/services';
import { LoadingService } from '../shared/services/components/loading.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Observable, of } from 'rxjs';
import * as moment from 'moment';
import { CnpjUtils } from '../shared/utils/cnpj.utils';

@Component({
  selector: 'app-conciliacao',
  templateUrl: './conciliacao.component.html',
  styleUrls: ['./conciliacao.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConciliacaoComponent implements OnInit {
  public formPesquisa!: FormGroup;
  public formConciliacao!: FormGroup;
  public loadingLista = false;
  public selected = '';
  public parcelaPaginado: ParcelaPaginado | null = null;
  public Filtro: FiltroConciliacao[] = [];
  public FiltroAcordo: FiltroAcordo[] = [];
  public comprovantes: ComprovanteContaCredito[] = [];
  public arquivos: ArquivoComprovanteContaCredito[] = [];
  public fileToUpload: String[] = [];
  public page: Paginacao | null = null;
  public valorARepassarSelecionado: number = 0;
  public qtdARepassarSelecionado: number = 0;
  public valorTotalComprovantes: number = 0;
  source: any[] = [];
  columnsTemplate: any[] = [];
  public tipoPessoa = 1;
  public procedenciasAcordo: ProcedenciaAcordo[] = [];
  public listaEscritoriosFiltro: any[] = [];
  public nomeEscritorioFiltro: any[] = [];
  private _submittedNovoComprovante = false;
  private _isSalvando = false;
  public listaContasCredito: ContaCredito[] = [];
  public transacao: TransacaoCredito = {};
  public parcelasSelecionadas: number[] = [];
  public dadosParcela: Parcela[] = [];
  public codigoEscritorio: number = 0;
  public nomeEscritorio: string = '';
  public isEscritorio: boolean = false;
  public escritorio: any = null;

  @ViewChild('templateDevedor') private templateDevedor!: TemplateRef<any>;
  @ViewChild('templateVencimento') private templateVencimento!: TemplateRef<any>;
  @ViewChild('templateValor') private templateValor!: TemplateRef<any>;
  @ViewChild('templateCoincidencia') private templateCoincidencia!: TemplateRef<any>;
  @ViewChild('templateSelecao') private templateSelecao!: TemplateRef<any>;
  @ViewChild('ModalConcluidoTransacao') modalConcluidoTransacao!: PsModalLoadingComponent;

  constructor(
    private formBuilder: FormBuilder,
    public parcelaService: ParcelaService,
    public transacaoCreditoService: TransacaoCreditoService,
    public usuarioService: UsuarioService,
    public escritorioService: EscritoriosService,
    private loading: LoadingService,
    public dominiosService: DominiosService,
    private contaCreditoService: ContaCreditoService,
    private router: Router,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.columnsTemplate = [
      { prop: 'acordo.processoRessarcimento.codigoRamoSinistro', label: 'Ramo' },
      { prop: 'acordo.processoRessarcimento.numeroSinistro', label: 'Sinistro' },
      { prop: 'acordo.processoRessarcimento.anoSinistro', label: 'Ano' },
      { prop: 'acordo.codigoAcordo', label: 'Acordo' },
      { prop: 'numeroParcela', label: 'N° parcela' },
      { label: 'Data de vencimento', template: this.templateVencimento },
      { prop: 'tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo', label: 'Status' },
      { label: 'Valor da parcela', template: this.templateValor },
      { label: 'Selecionar', template: this.templateSelecao },
      { label: 'Coincidência', template: this.templateCoincidencia },
      { prop: 'numeroTransacao.numeroTransacao', label: 'N° transação' },
      { label: 'Nome do Terceiro', template: this.templateDevedor },
    ] as any[];

    this.parcelaPaginado = null;

    this.criarFormPesquisa();
    this.criarFormConciliacao();
    this.carregarDadosPagina();

    this.parcelasSelecionadas = [];
  }

  carregarDadosPagina() {
    this.usuarioService.recuperarDadosUsuario().subscribe(result => {

      if (result.produto == 531) {
        this.columnsTemplate = this.columnsTemplate.filter(function(column) {
          return column.label !='N° transação';
        })
      }
      if (result.produto !== undefined) {
        this.carregarProcedenciasAcordo(result.produto);
      }
      this.carregarContasCredito();

      this.formPesquisa.controls['ramoSinistro'].setValue( result.produto );

      if( result.codigoEscritorio ) {
        this.codigoEscritorio = result.codigoEscritorio;
      }

      if( result.nomeEscritorio ) {
        this.nomeEscritorio = result.nomeEscritorio;
      }

      this.isEscritorio = result.flagEscritorio !== undefined ? result.flagEscritorio : false;
      if( this.isEscritorio ) {
        this.formPesquisa.controls['escritorio'].setValue( result.nomeEscritorio );
        this.formPesquisa.controls['codigoEscritorio'].setValue( result.codigoEscritorio );
      }
    });
  }

  public carregarContasCredito() {
    this.contaCreditoService.obterContasCredito().subscribe(result => {
      this.listaContasCredito = result;
    });
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      ramoSinistro: null,
      numeroSinistro: null,
      anoSinistro: null,
      sequenciaItemSinistro: null,
      codigoAcordo: null,
      tipoPessoa: null,
      cpfCnpj: null,
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : null,
      codigoEscritorio: this.codigoEscritorio != null ? this.codigoEscritorio : null,
      codigoProcedencia: null,
      statusParcela: null,
      codigoModalidade: null,
      Filtro: this.formBuilder.array([]),
      FiltroAcordo: this.formBuilder.array([])
    });
  }

  private criarFormConciliacao() {
    this.formConciliacao = this.formBuilder.group({
      comprovantes: this.formBuilder.array([]),
      anexos: this.formBuilder.array([]),
    });
  }

  public incluirComprovante() {
    const control = <FormArray>this.formConciliacao.controls['comprovantes'];
    control.push(this.formBuilder.group({ dataComprovante: null, valorComprovante: null, codigoContaCredito: null, observacao: null }));
  }

  public deleteRowComprovante(indexComprovante: any) {
    const control = <FormArray>this.formConciliacao.controls['comprovantes'];
    control.removeAt(indexComprovante);
  }

  public incluirFiltro() {
    var FiltroArray = this.formPesquisa.get('Filtro') as FormArray;
    if(FiltroArray.length <= 8){
    const control = <FormArray>this.formPesquisa.controls['Filtro'];
    control.push(this.formBuilder.group({ramoSinistro: 531, numeroSinistro: null, anoSinistro: null, sequenciaItemSinistro: null }));
  }
}

public incluirFiltroAcordo() {
  var FiltroAcordoArray = this.formPesquisa.get('FiltroAcordo') as FormArray;
  if(FiltroAcordoArray.length <= 8){
  const control = <FormArray>this.formPesquisa.controls['FiltroAcordo'];
  control.push(this.formBuilder.group({codigoAcordo: null }));
}
}

  public deleteRowFiltro(indexFiltro: any) {
    const control = <FormArray>this.formPesquisa.controls['Filtro'];
    control.removeAt(indexFiltro);
  }

  public deleteRowFiltroAcordo(indexFiltro: any) {
    const control = <FormArray>this.formPesquisa.controls['FiltroAcordo'];
    control.removeAt(indexFiltro);
  }

  public incluirAnexoComprovante() {
    const control = <FormArray>this.formConciliacao.controls['anexos'];
    control.push(this.formBuilder.group({ anexo: null }));
  }

  public deleteRowAnexoComprovante(indexAnexoComprovante: any) {
    const control = <FormArray>this.formConciliacao.controls['anexos'];
    control.removeAt(indexAnexoComprovante);
  }

  public changeParcelaSelecionada(event: any, codigoParcela: number): void {

    if (!this.parcelaPaginado || !this.parcelaPaginado.parcelas) return;
    var parcela = this.parcelaPaginado.parcelas.find((p: Parcela) => p.codigoParcela == codigoParcela);

    var target = event.target;
    if (parcela && target.checked) {
      this.parcelasSelecionadas.push(codigoParcela);
      this.dadosParcela.push(parcela);
      this.valorARepassarSelecionado = this.valorARepassarSelecionado + (parcela.valorParcela || 0);
      this.qtdARepassarSelecionado = this.qtdARepassarSelecionado + 1;
    } else if (parcela) {
      var index = this.parcelasSelecionadas.indexOf(codigoParcela);
      if (index > -1) {
        this.parcelasSelecionadas.splice(index, 1);
        this.dadosParcela.splice(this.dadosParcela.indexOf(parcela), 1);
        this.valorARepassarSelecionado = this.valorARepassarSelecionado - (parcela.valorParcela || 0);
        this.qtdARepassarSelecionado = this.qtdARepassarSelecionado - 1;
      }
    }
  }

  public isParcelaSelecionada(codigoParcela: number): boolean {
    return this.parcelasSelecionadas.indexOf(codigoParcela) != -1;
  }

  public log(event: any) {
    console.log(event);
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formPesquisa.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(data => {
        this.listaEscritoriosFiltro = data;
        for (let key in data) {
          this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
        }
      });
      return of(this.nomeEscritorioFiltro);
    };
  }

  public autoCompleteBuscaEscritorioSelected($event: any) {
    this.selected = $event;

    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  private carregarProcedenciasAcordo(produto: number | undefined): void {
    if (produto === undefined) return;
    this.dominiosService.obterProcedenciasAcordoPorRamo(produto).subscribe(result => {
      this.procedenciasAcordo = result;
    });
  }

  public pesquisarParcelas(page: any) {
    this._isSalvando = true;
    
    if (!this.validarFiltro()) {
      this._isSalvando = false;
      return;
    }
    if (!this.validarFiltroAcordo()) {
      this._isSalvando = false;
      return;
    }
    
    this.loading.open();
    this.parcelaPaginado = null;
    
    

    if (page == undefined) {
      this.qtdARepassarSelecionado = 0;
      this.valorARepassarSelecionado = 0;
      this.parcelasSelecionadas = [];
      this.dadosParcela = [];
    }

    let cpfCnpj = (this.formPesquisa.value['cpfCnpj'] != undefined) ? CnpjUtils.normalizar(this.formPesquisa.value['cpfCnpj']) : null;

    if (this.tratarCondicao(this.escritorio) == null && this.isEscritorio === false) {
      this.formPesquisa.controls['codigoEscritorio'].setValue(null);
    }
    var FiltroArray = this.formPesquisa.get('Filtro') as FormArray;
    var FiltroAcordoArray = this.formPesquisa.get('FiltroAcordo') as FormArray;
    var ramo = [];
    var numero = [];
    var ano = [];
    var sequencia = [];
    var codigo = [];
    for (var i = 0; i < FiltroArray.length; i++) {
      if (FiltroArray.length == i) {
        ramo[i] = null;
        numero[i] = null;
        ano[i] = null;
        sequencia[i] = null;
      } else {
        ramo[i] = this.tratarCondicao(FiltroArray.value[i].ramoSinistro) !== null ? Number(this.tratarCondicao(FiltroArray.value[i].ramoSinistro)) : null;
        numero[i] = this.tratarCondicao(FiltroArray.value[i].numeroSinistro) !== null ? Number(this.tratarCondicao(FiltroArray.value[i].numeroSinistro)) : null;
        ano[i] = this.tratarCondicao(FiltroArray.value[i].anoSinistro) !== null ? Number(this.tratarCondicao(FiltroArray.value[i].anoSinistro)) : null;
        sequencia[i] = this.tratarCondicao(FiltroArray.value[i].sequenciaItemSinistro) !== null ? Number(this.tratarCondicao(FiltroArray.value[i].sequenciaItemSinistro)) : null;
      }
    }
    for (var i = 0; i < FiltroAcordoArray.length; i++) {
      if (FiltroAcordoArray.length == i) {
        codigo[i] = null;
      } else {
        codigo[i] = this.tratarCondicao(FiltroAcordoArray.value[i].codigoAcordo) !== null ? Number(this.tratarCondicao(FiltroAcordoArray.value[i].codigoAcordo)) : null;
      }
    }
    var parametros: ParcelaService.ObterParcelasParaConciliacaoParams = {
      ramoSinistro: this.tratarCondicao(this.formPesquisa.value['ramoSinistro']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['ramoSinistro'])) : undefined,
      ramoSinistro1: ramo[0] != null ? Number(ramo[0]) : null,
      ramoSinistro2: ramo[1] != null ? Number(ramo[1]) : null,
      ramoSinistro3: ramo[2] != null ? Number(ramo[2]) : null,
      ramoSinistro4: ramo[3] != null ? Number(ramo[3]) : null,
      ramoSinistro5: ramo[4] != null ? Number(ramo[4]) : null,
      ramoSinistro6: ramo[5] != null ? Number(ramo[5]) : null,
      ramoSinistro7: ramo[6] != null ? Number(ramo[6]) : null,
      ramoSinistro8: ramo[7] != null ? Number(ramo[7]) : null,
      ramoSinistro9: ramo[8] != null ? Number(ramo[8]) : null,
      numeroSinistro: this.tratarCondicao(this.formPesquisa.value['numeroSinistro']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['numeroSinistro'])) : undefined,
      numeroSinistro1: numero[0] != null ? Number(numero[0]) : null,
      numeroSinistro2: numero[1] != null ? Number(numero[1]) : null,
      numeroSinistro3: numero[2] != null ? Number(numero[2]) : null,
      numeroSinistro4: numero[3] != null ? Number(numero[3]) : null,
      numeroSinistro5: numero[4] != null ? Number(numero[4]) : null,
      numeroSinistro6: numero[5] != null ? Number(numero[5]) : null,
      numeroSinistro7: numero[6] != null ? Number(numero[6]) : null,
      numeroSinistro8: numero[7] != null ? Number(numero[7]) : null,
      numeroSinistro9: numero[8] != null ? Number(numero[8]) : null,
      anoSinistro: this.tratarCondicao(this.formPesquisa.value['anoSinistro']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['anoSinistro'])) : undefined,
      anoSinistro1: ano[0] != null ? Number(ano[0]) : null,
      anoSinistro2: ano[1] != null ? Number(ano[1]) : null,
      anoSinistro3: ano[2] != null ? Number(ano[2]) : null,
      anoSinistro4: ano[3] != null ? Number(ano[3]) : null,
      anoSinistro5: ano[4] != null ? Number(ano[4]) : null,
      anoSinistro6: ano[5] != null ? Number(ano[5]) : null,
      anoSinistro7: ano[6] != null ? Number(ano[6]) : null,
      anoSinistro8: ano[7] != null ? Number(ano[7]) : null,
      anoSinistro9: ano[8] != null ? Number(ano[8]) : null,
      sequenciaItemSinistro: this.tratarCondicao(this.formPesquisa.value['sequenciaItemSinistro']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['sequenciaItemSinistro'])) : undefined,
      sequenciaItemSinistro1: sequencia[0] != null ? Number(sequencia[0]) : null,
      sequenciaItemSinistro2: sequencia[1] != null ? Number(sequencia[1]) : null,
      sequenciaItemSinistro3: sequencia[2] != null ? Number(sequencia[2]) : null,
      sequenciaItemSinistro4: sequencia[3] != null ? Number(sequencia[3]) : null,
      sequenciaItemSinistro5: sequencia[4] != null ? Number(sequencia[4]) : null,
      sequenciaItemSinistro6: sequencia[5] != null ? Number(sequencia[5]) : null,
      sequenciaItemSinistro7: sequencia[6] != null ? Number(sequencia[6]) : null,
      sequenciaItemSinistro8: sequencia[7] != null ? Number(sequencia[7]) : null,
      sequenciaItemSinistro9: sequencia[8] != null ? Number(sequencia[8]) : null,
      codigoAcordo: this.tratarCondicao(this.formPesquisa.value['codigoAcordo']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['codigoAcordo'])) : undefined,
      codigoAcordo1: codigo[0] != null ? Number(codigo[0]) : null,
      codigoAcordo2: codigo[1] != null ? Number(codigo[1]) : null,
      codigoAcordo3: codigo[2] != null ? Number(codigo[2]) : null,
      codigoAcordo4: codigo[3] != null ? Number(codigo[3]) : null,
      codigoAcordo5: codigo[4] != null ? Number(codigo[4]) : null,
      codigoAcordo6: codigo[5] != null ? Number(codigo[5]) : null,
      codigoAcordo7: codigo[6] != null ? Number(codigo[6]) : null,
      codigoAcordo8: codigo[7] != null ? Number(codigo[7]) : null,
      codigoAcordo9: codigo[8] != null ? Number(codigo[8]) : null,
      cpfCnpj: cpfCnpj !== null && cpfCnpj !== undefined && cpfCnpj !== '' ? cpfCnpj : undefined,
      codigoEscritorio: this.tratarCondicao(this.formPesquisa.value['codigoEscritorio']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['codigoEscritorio'])) : undefined,
      codigoTipoProcedencia: this.tratarCondicao(this.formPesquisa.value['codigoProcedencia']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['codigoProcedencia'])) : undefined,
      codigoStatus: this.tratarCondicao(this.formPesquisa.value['statusParcela']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['statusParcela'])) : undefined,
      codigoModalidade: this.tratarCondicao(this.formPesquisa.value['codigoModalidade']) != null ? Number(this.tratarCondicao(this.formPesquisa.value['codigoModalidade'])) : undefined,
      page: page == undefined ? 0 : Number(page),
      perPage: 10,
    }; 
  
    this.parcelaService.obterParcelasParaConciliacao(parametros).subscribe(response => {
      this.loading.close();
      this.parcelaPaginado = response;
      this.page = this.parcelaPaginado.paginacao || null;
      this.loadingLista = false;
      this.source = this.parcelaPaginado.parcelas || [];

    }, error => {
      this.loading.close();
      const theError: string = error.error.mensagens[2].mensagem;
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public pessoaFisicaChange(evt: any) {
    var target = evt.target;
    if (target.checked) {
      this.tipoPessoa = 1
    }
  }

  public pessoaJuridicaChange(evt: any) {
    var target = evt.target;
    if (target.checked) {
      this.tipoPessoa = 2
    }
  }

  public onAbrirModal(evento: any) {
    console.log("Abrindo modal de conciliação... ");
    this.limparDadosComprovantes();
  }

  public onFecharModal() {
    console.log("Fechando modal... ");
  }

  private limparDadosComprovantes() {

    var comprovantesArray = this.formConciliacao.get('comprovantes') as FormArray;
    while (comprovantesArray.length !== 0) {
      comprovantesArray.removeAt(0);
    }

    var anexoComprovantesArray = this.formConciliacao.get('anexos') as FormArray;
    while (anexoComprovantesArray.length !== 0) {
      anexoComprovantesArray.removeAt(0);
    }
  }

  handleUpload(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.fileToUpload.push(reader.result + "");
    };
  }

  public getSubmittedComprovante() {
    return this._submittedNovoComprovante;
  }

  public paginar(evt: any) {
    this.pesquisarParcelas(evt.offset);
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public calculaValorTotalComprovante() {
    this.valorTotalComprovantes = 0;
    const comprovantesArray = this.formConciliacao.get('comprovantes') as FormArray;
    if (comprovantesArray && comprovantesArray.length > 0) {
      for (let i = 0; i < comprovantesArray.length; i++) {
        this.valorTotalComprovantes += comprovantesArray.at(i).value.valorComprovante || 0;
      }
      this.valorTotalComprovantes = parseFloat(this.valorTotalComprovantes.toFixed(2));
    }
  }
  private validarFormulario(): boolean {
    var isValido = true;

    var comprovantesArray = this.formConciliacao.get('comprovantes') as FormArray;
    for (var i = 0; i < comprovantesArray.length; i++) {
      if (comprovantesArray.value[i].dataComprovante == null || comprovantesArray.value[i].dataComprovante == '') {
        isValido = false;
        this.formConciliacao.controls['comprovantes'].setErrors({ 'incorrect': true });
      }
      if (comprovantesArray.value[i].valorComprovante == null || comprovantesArray.value[i].valorComprovante == '') {
        isValido = false;
        this.formConciliacao.controls['comprovantes'].setErrors({ 'incorrect': true });
      }
      if (comprovantesArray.value[i].codigoContaCredito == null || comprovantesArray.value[i].codigoContaCredito == 0) {
        isValido = false;
        this.formConciliacao.controls['comprovantes'].setErrors({ 'incorrect': true });
      }
    }
    return isValido;
  }

  private validarFiltro(): boolean {
    var isValido = true;

    var FiltroArray = this.formPesquisa.get('Filtro') as FormArray;
    for (var i = 0; i < FiltroArray.length; i++) {
      if (FiltroArray.value[i].ramoSinistro == null || FiltroArray.value[i].ramoSinistro == '') {
        isValido = false;
        this.formPesquisa.controls['Filtro'].setErrors({ 'incorrect': true });
      }
      if (FiltroArray.value[i].numeroSinistro == null || FiltroArray.value[i].numeroSinistro == '') {
        isValido = false;
        this.formPesquisa.controls['Filtro'].setErrors({ 'incorrect': true });
      }
      if (FiltroArray.value[i].anoSinistro == null || FiltroArray.value[i].anoSinistro == '') {
        isValido = false;
        this.formPesquisa.controls['Filtro'].setErrors({ 'incorrect': true });
      }
      if (FiltroArray.value[i].sequenciaItemSinistro == null || FiltroArray.value[i].sequenciaItemSinistro == '') {
        isValido = false;
        this.formPesquisa.controls['Filtro'].setErrors({ 'incorrect': true });
      }
      if (isValido == false){
        var linha = i + 2;
        this.appComponent.createAlert('Preencha todos os campos do Ramo, Sinistro, Ano e Item da linha: '+ linha , 'alert');
      }
     
    }
    return isValido;
  }

  private validarFiltroAcordo(): boolean {
    var isValido = true;

    var FiltroAcordoArray = this.formPesquisa.get('FiltroAcordo') as FormArray;
    for (var i = 0; i < FiltroAcordoArray.length; i++) {
      if (FiltroAcordoArray.value[i].codigoAcordo == null || FiltroAcordoArray.value[i].codigoAcordo == '') {
        isValido = false;
        this.formPesquisa.controls['FiltroAcordo'].setErrors({ 'incorrect': true });
        var linha = i + 2;
        this.appComponent.createAlert('Preencha o Acordo da linha: '+ linha , 'alert');
      }
    }
    return isValido;
  }

  public salvarTransacao(componenteModalPadrao: any, componenteModalGravando: any) {

    this._isSalvando = true;
    this._submittedNovoComprovante = true;
    this.calculaValorTotalComprovante();

    if (this.valorARepassarSelecionado == 0 || this.qtdARepassarSelecionado == 0) {
      this.appComponent.createAlert('Você não selecionou nenhuma parcela para conciliar, por favor verifique sua seleção', 'alert');
      this._isSalvando = false;
      return;
    }

    if (!this.validarFormulario()) {
      this._isSalvando = false;
      return;
    }
     console.log(this.valorTotalComprovantes.toFixed(2) );
     console.log(this.valorARepassarSelecionado.toFixed(2));
    if (Number(this.valorTotalComprovantes.toFixed(2)) < Number(this.valorARepassarSelecionado.toFixed(2))) {
      this._isSalvando = false;
      this.appComponent.createAlert('A soma dos comprovantes é menor que valor total selecionado', 'alert');
      return;
    } else {
      componenteModalPadrao.close();
      componenteModalGravando.open("save");

      const comprovantesArray = this.formConciliacao.controls.comprovantes as FormArray;
      Object.keys(comprovantesArray.controls).forEach(key => {
        const comprovante: ComprovanteContaCredito = {};
        const control = comprovantesArray.get(key);

        comprovante.contaCredito = {}
        if (control) {
          comprovante.contaCredito.codigoContaCredito = Number(control.value['codigoContaCredito']);
          comprovante.dataComprovante = (moment as any).default
            ? (moment as any).default(control.value['dataComprovante'], "DD/MM/YYYY").format("YYYY-MM-DD")
            : (moment as any)(control.value['dataComprovante'], "DD/MM/YYYY").format("YYYY-MM-DD");
          comprovante.textoObservacao = control.value['observacao'];
          comprovante.valorComprovante = Number(control.value['valorComprovante']);
        }

        this.comprovantes.push(comprovante);
      });

      const anexosArray = this.formConciliacao.controls.anexos as FormArray;
      var idx = 0;
      Object.keys(anexosArray.controls).forEach(key => {
        const control = anexosArray.get(key);

        if (control && control.value && control.value.anexo) {
          const arquivo: ArquivoComprovanteContaCredito = {};
          arquivo.nome = control.value.anexo
          arquivo.conteudo = "" + this.fileToUpload[idx++];

          this.arquivos.push(arquivo);
        }
      });

      this.transacao.comprovantes = [];
      this.transacao.comprovantes = this.comprovantes;
      this.transacao.parcelaLista = {};
      this.transacao.parcelaLista.parcelas = this.dadosParcela;
      this.transacao.arquivos = [];
      this.transacao.arquivos = this.arquivos;

      this.transacaoCreditoService.conciliar(this.transacao).subscribe(response => {
        this.transacao.numeroTransacao = response.codigoTransacao;
        componenteModalGravando.close();
        this.modalConcluidoTransacao.open(null);
      }, error => {
        componenteModalGravando.close();
        this.appComponent.createAlert('Não foi possível salvar a transação', 'error');
      });
      this._isSalvando = false;
    }
  }

  public modalConcluidoTransacaoClick() {
    setTimeout(() => {
      this.router.navigate(['/detalhe-validacao/' + this.transacao.numeroTransacao]);
    }, 500);
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }
}
